/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createFractionClass } from '../../factoriesAny.js';
export var FractionDependencies = {
  createFractionClass: createFractionClass
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesFractionClass.generated.js
// module id = 113
// module chunks = 0